// Khung "Hoạt động" (nhật ký + bình luận + tag @) — markup giữ nguyên như V1.
import React from "react";
import Moment from "react-moment";
import parse from "html-react-parser";
import iconsend from "../../assets/img/icon-send.png";

export default function ActivityPanel({
  detail,
  user,
  listMessage,
  myMessage,
  onComment,
  sendMessage,
  usersSuggest,
  showSuggest,
  handleSelectUser,
  inputRef,
}) {
  const canComment = detail && (detail.im_in || detail.author_id == user.data.id);

  return (
    <div className="col-12 col-sm-3 form-group message-group">
      <div className="w-100 wrapper border rounded">
        <div className="w-100 ms-header p-2 border-bottom">
          <h5 className="w-100 text-center">Hoạt động</h5>
        </div>
        <div className="list-message">
          {listMessage &&
            listMessage.map((ms) => (
              <div className="w-100 message-item border-bottom" key={ms.id}>
                <strong>{ms.fullname}: </strong>
                <span style={{ whiteSpace: "pre-line" }}>{parse(ms.message || "")}</span>
                <br />
                <small>
                  <span className="far fa-clock"></span>{" "}
                  <Moment format="HH:mm DD/MM/YYYY">{new Date(ms.datecreate * 1000)}</Moment>
                </small>
              </div>
            ))}
        </div>
        {canComment ? (
          <>
            <div className="message-action border-top">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-comment-ttr"
                  placeholder="Nhập nội dung..."
                  value={myMessage}
                  ref={inputRef}
                  onChange={(e) => onComment(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Tab" && showSuggest && usersSuggest.length > 0) {
                      e.preventDefault();
                      handleSelectUser(usersSuggest[0]);
                      return;
                    }
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      sendMessage();
                    }
                  }}
                />
                <div className="input-group-prepend">
                  <button type="button" className="btn btn-sm btn-succss" onClick={() => sendMessage()}>
                    <img src={iconsend} alt="send" />
                  </button>
                </div>
              </div>
            </div>
            {showSuggest && usersSuggest.length > 0 && (
              <div className="users-suggest">
                {usersSuggest.map((u) => (
                  <div key={u.id} className="user-item" onClick={() => handleSelectUser(u)}>
                    <strong style={{ whiteSpace: "pre-line" }}>
                      {u.fullname}|{u.department_name}
                    </strong>
                  </div>
                ))}
              </div>
            )}
            <small className="text-10">Gõ @ để tags những người liên quan</small>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
